import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../../shared/shared.module';
import { PhotosAndVideoFormComponent } from './photos-and-video.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PhotoListModule } from '../../../../../../shared/photo-list/photo-list.module';
import { MultiFileUploadModule } from '../../../../../../shared/upload/multi-file-upload/multi-file-upload.module';
import { VesselSaveButtonModule } from '../../vessel-save-button/vessel-save-button.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    MatDialogModule,
    PhotoListModule,
    MultiFileUploadModule,
    VesselSaveButtonModule,
  ],
  declarations: [PhotosAndVideoFormComponent],
  entryComponents: [],
  exports: [PhotosAndVideoFormComponent],
  providers: [],
})
export class PhotosAndVideoFormModule {}
